// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"5":"home-desktop-taxonomy-css","671":"home-desktop-taxonomy","939":"browse-card-ui"}[chunkId] || chunkId) + "-" + {"5":"ed00b595ab","289":"132a51fcc1","671":"10c377e0c7","939":"110680e9e7"}[chunkId] + ".js";
};